<template>
	<div class="pc-interior">
		<div class="section top">
			<swiper
				:modules="modules"
				:slides-per-view="1"
				:autoplay="{ delay: 4000 }"
				:loop="true"
				:scrollbar="{ draggable: true }"
				navigation
				effect="fade"
			>
				<swiper-slide class="swiper-slide bg-1">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-2">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
						<div class="box">
							<div class="case en">Interior Case 01</div>
							<div class="tit">'강남 파노라마 뷰' 오픈형 오피스</div>
							<div class="time">약 5주 소요</div>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-3">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
						<div class="box">
							<div class="case en">Interior Case 02</div>
							<div class="tit">포인트 컬러를 활용한 위메프 오피스</div>
							<div class="time">약 5주 소요</div>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-4">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
						<div class="box">
							<div class="case en">Interior Case 03</div>
							<div class="tit">커튼월 채광이 좋은 150평대 오피스</div>
							<div class="time">약 4주 소요</div>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-5">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
						<div class="box">
							<div class="case en">Interior Case 04</div>
							<div class="tit">화이트톤의 세련된 '카페 Vibe' 오피스</div>
							<div class="time">약 4주 소요</div>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-6">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
						<div class="box">
							<div class="case en">Interior Case 05</div>
							<div class="tit">오션테크 기업을 위한 유니크한 오피스</div>
							<div class="time">약 4주 소요</div>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-7">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-8">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-9">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-10">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-11">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-12">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide bg-13">
					<div class="con-wrap">
						<div class="text">
							유니크한 기업을 만드는<br />
							ONE-STOP 인테리어 솔루션
						</div>
					</div>
				</swiper-slide>
			</swiper>
		</div>
		<div class="section center type-flex">
			<div class="sub">복잡한 오피스 인테리어 과정으로 낭비되는</div>
			<div class="tit txt-c--primary">
				고객님의 소중한 시간과 비용,<br />
				이제는 아낄 수 있습니다.
			</div>
			<div class="icon-box">
				<div class="box">
					<div class="icon icon-1"></div>
					<span class="name">A 스타트기업 대표</span>
					<div class="chat"><strong>디자인을 먼저</strong>확인하고 결정할 수 없을까요?</div>
				</div>
				<div class="box">
					<div class="icon icon-2"></div>
					<span class="name">B 기업 총무팀 담당자</span>
					<div class="chat"><strong>견적</strong>이 얼마나 나올지 <strong>미리</strong> 알고싶어요!</div>
				</div>
				<div class="box">
					<div class="icon icon-3"></div>
					<span class="name">C 스타트업 대표</span>
					<div class="chat">
						시간과 비용 낭비 없이
						<strong>디자인과 시공을 한 번에</strong>
						해결하고 싶어요
					</div>
				</div>
			</div>
			<div class="primary-box">
				<strong>위온어스에서 ‘무료’로 디자인&견적 먼저 받아보고 결정하세요.</strong><br />
				오피스 전문 토탈 디자인 서비스 전문가가 인테리어 고민을 덜어드립니다.
			</div>
		</div>
		<div class="section center type-slide">
			<div class="tit">
				중대형 오피스 구축을 위한 파트너로<br />
				기업의 시작을 함께합니다.
			</div>
			<div class="sub">
				체계적인 프로세스에 강한 기술력으로 기업 비즈니스에 최적화된 원스톱 오피스 솔루션을 제공합니다.
			</div>
			<swiper
				class="img-slide"
				:modules="modules"
				:slides-per-view="3"
				:loop="true"
				:centeredSlides="true"
				:breakpoints="{
					'660': {
						slidesPerView: 5,
					},
				}"
			>
				<swiper-slide class="swiper-slide">
					<img src="../assets/images/pc/interior_img_1.png" alt="" />
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<img src="../assets/images/pc/interior_img_1_2.png" alt="" />
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<img src="../assets/images/pc/interior_img_1_3.png" alt="" />
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<img src="../assets/images/pc/interior_img_1_4.png" alt="" />
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<img src="../assets/images/pc/interior_img_1_5.png" alt="" />
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<img src="../assets/images/pc/interior_img_1_6.png" alt="" />
				</swiper-slide>
			</swiper>
		</div>
		<div class="section">
			<div class="flex">
				<div class="text">
					<div class="tit">
						실제같은 VR 서비스로<br />
						미리 확인하는 사무실공간
					</div>
					<div class="sub">
						스마트하고 체계적인 인테리어 프로세스를 제공합니다.<br />
						VR서비스를 통해 오차 없는 디자인 품질을 보장하고 데일리 리포트를 통해 매일 시공현황을 확인해보세요.
					</div>
				</div>
				<div class="img">
					<img src="../assets/images/pc/interior_img_2.png" alt="" />
				</div>
			</div>
			<div class="flex">
				<div class="text">
					<div class="tit">
						모듈화 서비스를 활용한<br />
						기업 이미지에 최적화 된<br />
						맞춤 디자인 제안
					</div>
					<div class="sub">
						폭 넓은 DB를 통해 고객 맞춤 사무실 공간의 컨셉을 제안합니다. <br />
						기업 비즈니스에 최적화된 브랜드별 사무 가구 큐레이션을 제안합니다.<br />
						방음 부스, 라운드 소파 등 고객 맞춤 가구를 제작합니다.
					</div>
				</div>
				<div class="img">
					<img src="../assets/images/pc/interior_img_2_2.png" alt="" />
				</div>
			</div>
			<div class="flex">
				<div class="text">
					<div class="tit">
						투명하고 합리적인<br />
						정찰제 견적 시스템
					</div>
					<div class="sub">
						공간 모듈에 기반하여 표준 견적가로 산출하는 견적 시스템을 제공하여 오래 사용할 수 있는 마감제를
						제안드립니다.<br />
						고객에게 필요한 옵션을 반영해 기업의 공간마련을 도와드립니다.
					</div>
				</div>
				<div class="img">
					<img src="../assets/images/pc/interior_img_2_3.png" alt="" />
				</div>
			</div>
			<div class="flex">
				<div class="text">
					<div class="tit">
						철저한 A/S 시스템,<br />
						인테리어 <span class="txt-c--primary">113</span> 현장 방문 서비스
					</div>
					<div class="sub">
						준공 후 한달에 한번, 3달 간 정기적 케어서비스를 제공합니다.<br />
						준공 체크리스트를 통해 전단계에 걸쳐 꼼꼼하게 진행합니다.<br />
						<br />
						하자보증이행증권과 전담A/S팀을 편성해 기업의 공간마련을 책임집니다.
					</div>
				</div>
				<div class="img">
					<img src="../assets/images/pc/interior_img_2_4.png" alt="" />
				</div>
			</div>
		</div>
		<div class="section">
			<ul class="history-list">
				<li class="history-list--item">
					<div class="tit"><strong class="num">01</strong>상담</div>
					<div class="con">
						<div class="tit">서비스 상담 신청</div>
						<div class="sub">홈페이지를 통해 서비스 상담을 신청합니다.</div>
						<div class="tit">그래프 D.B 기반 분석</div>
						<div class="sub">프로젝트 관련 사전 질문지를 작성합니다.</div>
						<div class="tit">디자인 미팅 & 계약</div>
						<div class="sub">디자인 시안과 견적을 바탕으로 프로젝트 착수 계약을 진행합니다.</div>
					</div>
				</li>
				<li class="history-list--item">
					<div class="tit"><strong class="num">02</strong>설계 & 시공</div>
					<div class="con">
						<div class="tit">VR & 모듈화 설계</div>
						<div class="sub">3D 시뮬레이션 VR로 최종 결과물을 미리 확인합니다.</div>
						<div class="tit">착공</div>
						<div class="sub">직영 시공팀이 투입되어 공사를 진행합니다.</div>
						<div class="tit">데일리 리포트</div>
						<div class="sub">전담 매니저가 매일매일의 공사 진행상황을 공유합니다.</div>
					</div>
				</li>
				<li class="history-list--item">
					<div class="tit"><strong class="num">03</strong>준공</div>
					<div class="con">
						<div class="tit">공사 완료</div>
						<div class="sub">프로젝트 기간을 엄수해 완공합니다.</div>
						<div class="tit">준공 체크리스트 확인</div>
						<div class="sub">전담 매니저가 방문해 고객과 함께 꼼꼼하게 준공 검사를 진행합니다.</div>
					</div>
				</li>
				<li class="history-list--item">
					<div class="tit"><strong class="num">04</strong>관리</div>
					<div class="con">
						<div class="tit">1.1.3 A/S 서비스</div>
						<div class="sub">한 달에 한 번씩, 3개월 간 매니저가 방문해 공사 후 케어 서비스를 진행합니다.</div>
						<div class="tit">하자보증이행증권 발행</div>
						<div class="sub">하자보증이행증권 발행 (1년) 및 전담 팀을 통한 A/S 관리가 이뤄집니다.</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="section bottom">
			<div class="text">
				새로운 오피스 라이프의 첫 걸음,<br />
				지금 시작해보세요.
				<button type="button" class="btn">서비스 신청</button>
			</div>
		</div>
	</div>
	<div class="footer">
		<div class="footer-wrap">
			<div class="footer-logo"></div>
			<div class="footer-info">
				<div class="line">
					<span>대표 : 서치원</span>
					<span>사업자 등록번호 : 395-87-02794</span>
					<span>주소 : 서울특별시 강남구 도산대로26길 20, 1층(논현동, NEWTURN빌딩)</span>
				</div>
				<div class="line">
					<span>대표번호 : 02-6956-2791</span>
					<span>팩스 : 070-4693-5728</span>
				</div>
			</div>
			<div class="footer-copy">
				개인정보처리방침<br />
				Copyrightⓒ2023 WEONUS All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>
import { Autoplay, Navigation, Scrollbar, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
	name: 'PC_Interior',
	components: { Swiper, SwiperSlide },
	computed: {},
	data() {
		return {
			swiper: null,
			modules: [Autoplay, Navigation, Scrollbar, EffectFade],
		};
	},
	created() {
		let header = document.querySelector('.header');
		let headerHeight = header.offsetHeight;
		let scroll = document.querySelector('body');
		scroll.addEventListener('scroll', function () {
			let windowTop = scroll.scrollTop;
			if (windowTop >= headerHeight) {
				header.classList.add('drop');
			} else {
				header.classList.remove('drop');
			}
		});
	},
	methods: {},
};
</script>
